import {FunctionalComponent, h} from "@stencil/core";

const TRUSTCAPTCHA_URL = 'https://www.trustcomponent.com/en/products/captcha';

interface TrustcaptchaProps{
  currentTheme: 'light' | 'dark',
  translation: any,
}

export const TrustcaptchaText: FunctionalComponent<TrustcaptchaProps> = ({ currentTheme, translation}) => (
  <a class='text-[10px] text-right hover:underline font-semibold' href={TRUSTCAPTCHA_URL} target='_blank' role="link" aria-label={translation.srTrustcaptcha}
     style={{color: currentTheme === 'light' ? '#2563eb' : '#60a5fa'}}>Trust
    <span class={{'text-gray-700': currentTheme === 'light', 'text-white': currentTheme === 'dark'}}>Captcha</span>
  </a>
)

interface PrivacyProps {
  privacyUrl: string,
  translation: any,
}

export const PrivacyText: FunctionalComponent<PrivacyProps> = ({ privacyUrl, translation }) => (
  <a
    class={{'text-xs text-right hover:text-blue-500 hover:underline': true}} href={privacyUrl} target='_blank' role="link" aria-label={translation.srPrivacy}>{translation.endPrivacyPolicy}
  </a>
)

interface SpinnerProps {
  size: number,
  stroke: number,
}

export const SpinnerIcon: FunctionalComponent<SpinnerProps> = ({size, stroke}) => (
  <svg class="spinner" viewBox="0 0 50 50" width={size} height={size} aria-hidden="true" focusable="false">
    <circle class="path" cx="25" cy="25" r="20" fill="none" stroke-width={stroke}></circle>
  </svg>
);

interface IconProps {
  size: number,
}

interface CheckIconProps {
  size: number,
  color?: string,
}

export const CheckIcon: FunctionalComponent<CheckIconProps> = ({ size, color }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill={color ?? '#16a34a'} width={size} height={size} aria-hidden="true" focusable="false">
    <path fill-rule="evenodd" d="M19.916 4.626a.75.75 0 01.208 1.04l-9 13.5a.75.75 0 01-1.154.114l-6-6a.75.75 0 011.06-1.06l5.353 5.353 8.493-12.739a.75.75 0 011.04-.208z" clip-rule="evenodd"/>
  </svg>
)

export const ErrorIcon: FunctionalComponent<IconProps> = ({ size }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="#dc2626" width={size} height={size} aria-hidden="true" focusable="false">
    <path fill-rule="evenodd" d="M9.401 3.003c1.155-2 4.043-2 5.197 0l7.355 12.748c1.154 2-.29 4.5-2.599 4.5H4.645c-2.309 0-3.752-2.5-2.598-4.5L9.4 3.003zM12 8.25a.75.75 0 01.75.75v3.75a.75.75 0 01-1.5 0V9a.75.75 0 01.75-.75zm0 8.25a.75.75 0 100-1.5.75.75 0 000 1.5z" clip-rule="evenodd"/>
  </svg>
)

export const LogoIcon: FunctionalComponent<IconProps> = ({size}) => (
  <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 428.2 428.2" aria-hidden="true" focusable="false">
    <path d="M393.8,110.2c-0.5-11.3-0.5-22-0.5-32.7c0-8.5-6.9-15.4-15.4-15.4c-64,0-112.6-18.4-153.1-57.9
                      c-6.1-5.6-15.4-5.6-21.5,0c-40.4,39.4-89.1,57.8-153.1,57.9c-8.5,0-15.4,6.9-15.4,15.4c0,10.7,0,21.5-0.5,32.7
                      c-2,107.5-5.1,255,174.6,316.9l5.1,1l5.1-1C398.4,365.2,395.8,218.2,393.8,110.2z M202.2,258.9c-0.2,0.2-0.5,0.4-0.7,0.7
                      c-3,2.4-6.4,3.8-10.4,3.8h-0.5c-4.1,0-8.2-2-10.8-5.1l-39.5-43.8c-4.4-4.9-4-12.5,0.9-16.9l5.2-4.6c4.9-4.4,12.4-3.9,16.8,0.9
                      l21.2,23.5c4.5,5,12.2,5.3,17.1,0.7l65.3-62.1c4.8-4.6,12.4-4.3,17,0.5l4.7,5c4.5,4.8,4.2,12.3-0.6,16.9L202.2,258.9z"/>
  </svg>
)
